<template>
  <div id="resumeEditor">
    I am resumeEditor
  </div>
</template>
 
<script>
export default {
  name: 'ResumeEditor'
}
</script>
 
<style>
#resumeEditor {
  background: #ffffff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.25);
}
</style>


// WEBPACK FOOTER //
// ResumeEditor.vue?1b0ced98